/** Today is in range of dates */
export function todayInRange(today: Date, start: Date, end: Date): boolean {
  return today >= start && today <= end;
}
